import { render, staticRenderFns } from "./UiLayoutContent.vue?vue&type=template&id=3b1c442c&scoped=true"
import script from "./UiLayoutContent.vue?vue&type=script&lang=js"
export * from "./UiLayoutContent.vue?vue&type=script&lang=js"
import style0 from "./UiLayoutContent.vue?vue&type=style&index=0&id=3b1c442c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c442c",
  null
  
)

export default component.exports